/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box, Card, Modal} from '@mui/material';
import ContactViewPage from '../pages/ContactViewPage';

type Props = {
  contactId: string;
  contactImportId: string;
  closeContactModal: () => void;
  calibrationMode?: boolean;
};

export const ContactModal = ({contactId, contactImportId, closeContactModal, calibrationMode}: Props) => {
  return (
    <Modal open={!!contactId && !!contactImportId} onClose={closeContactModal}>
      <Box
        component={'main'}
        sx={{
          '--Content-paddingX': 'calc(4 * var(--mui-spacing))',
          '--Content-paddingY': {
            xs: 'calc(4 * var(--mui-spacing))',
            lg: '64px',
          },
          '--Content-padding': 'var(--Content-paddingY) var(--Content-paddingX)',
          '--Content-width': '100%',
          maxWidth: 'var(--maxWidth-xl)',
          width: 'var(--Content-width)',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Card
          sx={{
            p: 'var(--Content-padding)',
            maxHeight: 'calc(100vh - calc(2 * var(--Content-paddingX)))',
            overflowY: 'auto',
            minHeight: 'calc(100vh - calc(2 * var(--Content-paddingX)))',
          }}
        >
          <ContactViewPage
            contactImportId={contactImportId}
            contactId={contactId}
            calibrationMode={calibrationMode}
            onCloseCalibrationModal={closeContactModal}
          />
        </Card>
      </Box>
    </Modal>
  );
};
